<script>
    import { selectedMuscleGroups } from './stores/muscleGroupStore';

    export let muscleId;
    export let name;
    $: selected = $selectedMuscleGroups.includes(muscleId)
</script>

<style>
    label {
        cursor: pointer;
        border-radius: 4px;
        background-color: var(--colorElementOpaque2);
        font-size: 13px; /* Set to px instead of rem due to problems with fitting all boxes in two columns at zoom. */
        color: var(--colorFg);
        margin-bottom: var(--spacingSmall);
        padding: var(--spacingTween) var(--spacingMedium);
        width: 40vw;
        max-width: 250px;
        text-align: left;
    }

    input {
        opacity: 0;
        position: absolute;
    }

    input:checked + label{
        background-color: var(--colorElement);
        color: var(--colorFgInverse);
    }

    @media screen and (max-width: 500px) {
        label {
            width: 90%;
        }
    }
</style>

<input
    class:selected
    type=checkbox
    {name}
    id={name}
    value={name}
    bind:checked={selected}
    on:click={() => {
        if (selected) {
            selectedMuscleGroups.remove(muscleId)
        } else {
            selectedMuscleGroups.add(muscleId)
        }
    }}
/>
<label for="{name}">
    <slot/>
</label>
